import React from "react";
import { Provider } from "react-redux";
import store from "../stores/reduxStore";
import { Router, Route } from "react-router-dom";
import browserHistory from "../helpers/history";
import { ThemeProvider } from "styled-components";

import NounProjectHeader from "../components/nounproject-header";

import theme from "../themes/theme";

class NounProjectHeaderParent extends React.Component {
    render() {
        return (
            <ThemeProvider theme={theme}>
                <Provider store={store}>
                    <Router history={browserHistory}>
                        <Route
                            component={(routerProps) => (
                                <NounProjectHeader
                                    {...this.props}
                                    {...routerProps}
                                />
                            )}
                        />
                    </Router>
                </Provider>
            </ThemeProvider>
        );
    }
}

export default NounProjectHeaderParent;
